import { HStack, VStack, Text, Box } from '@chakra-ui/react';
import DraggableComponentGrid from './editor_components/draggable_grid';
import { useRef, useState, useEffect } from 'react';
import { widgets, widgets1 } from '../pages/widgets';
import {
  createHiddenDocument,
  removeHiddenDocument,
} from './editor_components/virtual_theme_core';
import { extractScripts } from './editor_components/extract_script_core';

const WidgetsGrid = ({
  parentRef,
  resultHtml,
  setResultHtml,
  save,
  setSave,
}) => {
  const widgetsRef = useRef();
  const containerRef = useRef();
  const [hiddenTheme1, setHiddentheme1] = useState(document);
  const [hiddenTheme, setHiddentheme] = useState(document);
  useEffect(() => {
    setHiddentheme(createHiddenDocument(widgets));
    setHiddentheme1(createHiddenDocument(widgets1));
  }, [widgets, widgets1]);
  const widgetsTheme = hiddenTheme.getElementsByClassName('analog-clock-M');
  const widgetsTheme1 = hiddenTheme1.getElementsByClassName('analog-clock-M');
  const clockxl0 = hiddenTheme.getElementsByClassName('digital-clock-XL');
  const clockxl1 = hiddenTheme1.getElementsByClassName('digital-clock-XL');
  const clockL0 = hiddenTheme.getElementsByClassName('digital-clock-L');
  const clockL1 = hiddenTheme1.getElementsByClassName('digital-clock-L');
  const clockM0 = hiddenTheme.getElementsByClassName('digital-clock-M');
  const clockM1 = hiddenTheme1.getElementsByClassName('digital-clock-M');
  const clockS0 = hiddenTheme.getElementsByClassName('digital-clock-S');
  const clockS1 = hiddenTheme1.getElementsByClassName('digital-clock-S');
  console.log(Array.from(hiddenTheme1.getElementsByClassName('rates-M')));
  let buffer = [];
  for (let elem of widgetsTheme) {
    buffer.push(
      <DraggableComponentGrid
        parentRef={parentRef}
        html={elem.outerHTML}
        widgetsRef={widgetsRef}
        script={extractScripts(elem)}
        key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
        fromTheme={true}
      />
    );
  }
  for (let elem of widgetsTheme1) {
    buffer.push(
      <DraggableComponentGrid
        parentRef={parentRef}
        html={elem.outerHTML}
        widgetsRef={widgetsRef}
        script={extractScripts(elem)}
        key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
        fromTheme={true}
      />
    );
  }

  return (
    <HStack
      width={'90vw'}
      overflowX={'scroll'}
      overflowY={'hidden'}
      ref={widgetsRef}
      id="widgets_overflow"
      onClick={() =>
        console.log(hiddenTheme1.getElementsByClassName('company-L'))
      }
    >
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Аналоговые часы
        </Text>
        <HStack gap={'10px'} className="analog" padding={'10px'} id="analog">
          <DraggableComponentGrid
            parentRef={parentRef}
            html={`<div class="design-3 widget-news-11-1-grid news-L">
      <p id="header-news-11-1">------</p>
      <p id="header-news-11-1-2">------</p>
      <p id="header-news-11-1-3">------</p>
      <style>
        @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
        * {
          margin: 0;
          padding: 0;
        }
        :root {
          --size-2: 246px;
          --size-4: 508px;
          --background-widgets: rgba(255, 255, 255, 1);
          --text-color: rgba(55, 55, 55, 1);
        }
        .design-3 {
          background-color: var(--background-widgets);
          border-radius: 32px;
        }
        .widget-news-11-1-grid {
          width: 392px;
          height: 377px;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          overflow-y: hidden;
        }
        .widget-news-11-1-grid p {
          color: var(--text-color);
          font-family: Rubik;
          font-weight: 300;
          font-size: 20px;
          text-align: start;
          margin-left: 32px;
          padding-left: 16px;
          margin-right: 32px;
          border-left: 3px solid var(--text-color);
        }
      </style>
      <script>
        const getNews_11_1 = () => {
          fetch("https://admin.i-panel.pro:8787/api/parse/news", {
            method: "GET",
            headers: {
              accept: "application/json",
            },
          })
            .then((response) => response.json())
            .then((result) => {
              console.log(result);
              let news = result.filter((elem) => elem.length <= 60);
              console.log(news);
              document.getElementById("header-news-11-1").innerHTML = news[0];
              document.getElementById("header-news-11-1-2").innerHTML =
                news[1];
              document.getElementById("header-news-11-1-3").innerHTML =
                news[2];
            });
        };
        setTimeout(() => {
          setInterval(() => {
            getNews_11_1();
          }, 300000);
          getNews_11_1();
        }, 5000);
      </script>
    </div>`}
            script={`
      `}
            key={100823791}
            fromTheme={true}
            widgetsRef={widgetsRef}
          />
          <DraggableComponentGrid
            parentRef={parentRef}
            html={`<div class="design-1 video company-L widget-about-company-11-3-widget">
      <video
        id="videoPlayer"
        autoplay
        poster="http://legacy.reactjs.org/logo-og.png"
      >
      </video>
      <style>
        
        .video video {
          object-fit: fill;
          width: 508px;
          height: 276px;
          border-radius: 32px;
        }
      </style>
      <script>
        const player = async () => {
          let currentVideoIndex = 0;
          let videoSources = [];
          const getVideos = async () => {
            const response = await fetch(
              \`https://admin.i-panel.pro:8787/api/files/files/\${panelId}\`,
              {
                method: "GET",
                headers: { Accept: "application/json" },
              }
            );
            const result = await response.json();
            videoSources = result.files.filter((elem) => elem.endsWith(".mp4"));
            videoSources = videoSources.map(
              (elem) => "https://admin.i-panel.pro:8787" + elem
            );
            console.log(videoSources);
          };
          await getVideos();
          const videoPlayer = document.getElementById("videoPlayer");
          const loadNext = async () => {
            currentVideoIndex == videoSources.length - 1
              ? (currentVideoIndex = 0)
              : (currentVideoIndex += 1);
            videoPlayer.src = videoSources[currentVideoIndex];
            videoPlayer.load();
            videoPlayer.play();
          };
          videoPlayer.src = videoSources[currentVideoIndex];
          videoPlayer.load();
          videoPlayer.play();

          videoPlayer.addEventListener("ended", loadNext);
          setInterval(getVideos, 1800000);
        };
        player();
      </script>
    </div>`}
            widgetsRef={widgetsRef}
            script={''}
            key={123123123} // добавьте уникальный ключ для каждого элемента
            fromTheme={true}
          />
          {Array.from(widgetsTheme).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
          {Array.from(widgetsTheme1).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Цифровые часы XL
        </Text>
        <HStack
          gap={'10px'}
          className="digitalClockXL"
          padding={'10px'}
          id="digitalClockXL"
        >
          {Array.from(clockxl0).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
          {Array.from(clockxl1).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Цифровые часы L
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="digitalClockL"
        >
          {Array.from(clockL0).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
          {Array.from(clockL1).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Цифровые часы M
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="digitalClockM"
        >
          {Array.from(clockM0).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
          {Array.from(clockM1).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Цифровые часы S
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="digitalClockS"
        >
          {Array.from(clockS0).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
          {Array.from(clockS1).map(elem => {
            return (
              <DraggableComponentGrid
                parentRef={parentRef}
                html={elem.outerHTML}
                widgetsRef={widgetsRef}
                script={extractScripts(elem)}
                key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                fromTheme={true}
              />
            );
          })}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Календари XL
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="calendarsXL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('calendar-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('calendar-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Календари L
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="calendarsL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('dates-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('dates-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Календари M
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="calendarsM"
        >
          {Array.from(hiddenTheme.getElementsByClassName('dates-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('dates-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Календари S
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="calendarsS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('dates-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('dates-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Календари XS
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="calendarsXS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('dates-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('dates-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Погода XL
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="weatherXL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('weather-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('weather-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Погода L
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="weatherL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('weather-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('weather-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Погода M
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="weatherM"
        >
          {Array.from(hiddenTheme.getElementsByClassName('weather-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('weather-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Погода S
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="weatherS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('weather-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('weather-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Погода XS
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="weatherXS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('weather-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('weather-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Пробки XL
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="trafficXL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('traffic-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('traffic-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Пробки L
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="trafficL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('traffic-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('traffic-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Пробки M
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="trafficM"
        >
          {Array.from(hiddenTheme.getElementsByClassName('traffic-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('traffic-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Пробки S
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="trafficS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('traffic-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('traffic-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Пробки XS
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="trafficXS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('traffic-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('traffic-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Новости
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="news1"
        >
          {Array.from(hiddenTheme.getElementsByClassName('news-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('news-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Курс валют XL
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="courseXL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('rates-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('rates-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Курс валют L
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="courseL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('rates-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('rates-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Курс валют M
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="courseM"
        >
          {Array.from(hiddenTheme.getElementsByClassName('rates-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('rates-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Курс валют S
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="courseS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('rates-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('rates-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Курс валют XS
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="courseXS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('rates-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('rates-XS')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Металлы XL
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="metalsXL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('metal-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('metal-XL')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Металлы L
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="metalsL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('metal-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('metal-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Металлы M
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="metalsM"
        >
          {Array.from(hiddenTheme.getElementsByClassName('metal-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('metal-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Металлы S
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="metalsS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('metal-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('metal-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Инфо о компании
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="about"
        >
          {Array.from(hiddenTheme.getElementsByClassName('company-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('company-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Музыка L
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="musicL"
        >
          {Array.from(hiddenTheme.getElementsByClassName('music-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('music-L')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Музыка M
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="musicM"
        >
          {Array.from(hiddenTheme.getElementsByClassName('music-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('music-M')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
      <VStack justify={'flex-start'}>
        <Text
          fontSize={24}
          color="#4945FF"
          alignSelf={'flex-start'}
          paddingLeft={'10px'}
        >
          Музыка S
        </Text>
        <HStack
          gap={'10px'}
          className="grid_widgets"
          padding={'10px'}
          id="musicS"
        >
          {Array.from(hiddenTheme.getElementsByClassName('music-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
          {Array.from(hiddenTheme1.getElementsByClassName('music-S')).map(
            elem => {
              return (
                <DraggableComponentGrid
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                  key={elem.outerHTML} // добавьте уникальный ключ для каждого элемента
                  fromTheme={true}
                />
              );
            }
          )}
        </HStack>
      </VStack>
    </HStack>
  );
};

export default WidgetsGrid;
